export const features = [
  {
    icon: 'ri-flashlight-line',
    title: 'Fast Product Discovery',
    description: 'Browse thousands of organized product recommendations across every category imaginable, saving you countless hours of manual searching.',
  },
  {
    icon: 'ri-search-eye-line',
    title: 'QC Information',
    description: 'Access detailed quality control insights and real user feedback so you understand exactly what you are buying before placing an order.',
  },
  {
    icon: 'ri-book-open-line',
    title: 'Shopping Guides',
    description: 'Follow step-by-step tutorials designed for complete beginners, covering everything from account setup to placing your first order confidently.',
  },
  {
    icon: 'ri-ship-line',
    title: 'Shipping Knowledge',
    description: 'Master Sugargoo shipping costs, compare international shipping lines, and learn how to minimize delivery expenses for your packages.',
  },
  {
    icon: 'ri-coupon-line',
    title: 'Money Saving',
    description: 'Discover the latest Sugargoo coupons, discount codes, and proven strategies to stretch your shopping budget further every time.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Safety Education',
    description: 'Learn essential tips for secure international shopping, protecting your payments, and avoiding common pitfalls in the agent shopping process.',
  },
];

export const guideHub = [
  {
    title: 'Sugargoo Spreadsheet',
    subtitle: 'Complete product discovery database',
    icon: 'ri-database-2-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20clean%20organized%20spreadsheet%20interface%20displayed%20on%20a%20minimal%20monitor%2C%20product%20thumbnails%20neatly%20arranged%2C%20warm%20sand%20and%20cream%20color%20palette%2C%20soft%20natural%20lighting%2C%20modern%20workspace%20aesthetic%2C%20editorial%20photography%2C%20clean%20composition&width=400&height=240&seq=guide-spread-v2&orientation=landscape',
    slug: '/article/what-is-sugargoo-spreadsheet',
    internal: true,
  },
  {
    title: 'Sugargoo Review',
    subtitle: 'In-depth 2026 analysis',
    icon: 'ri-star-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20modern%20review%20concept%20with%20star%20ratings%20and%20product%20images%20on%20a%20clean%20tablet%20screen%2C%20warm%20terracotta%20and%20cream%20palette%2C%20soft%20natural%20lighting%2C%20editorial%20style%2C%20professional%20aesthetic&width=400&height=240&seq=guide-review-v2&orientation=landscape',
    slug: '/article/sugargoo-review-2026',
    internal: true,
  },
  {
    title: 'Sugargoo Shipping Cost',
    subtitle: 'Real price breakdown guide',
    icon: 'ri-global-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20clean%20shipping%20concept%20with%20stylish%20packages%20and%20a%20small%20world%20globe%20on%20a%20minimal%20desk%2C%20warm%20sand%20and%20peach%20color%20palette%2C%20soft%20natural%20lighting%2C%20modern%20editorial%20photography&width=400&height=240&seq=guide-shipping-v2&orientation=landscape',
    slug: '/article/sugargoo-shipping-cost',
    internal: true,
  },
  {
    title: 'Sugargoo Warehouse',
    subtitle: 'How warehousing works',
    icon: 'ri-building-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=An%20organized%20warehouse%20concept%20with%20neatly%20stacked%20boxes%20on%20modern%20shelving%2C%20warm%20cream%20and%20terracotta%20color%20palette%2C%20soft%20natural%20lighting%2C%20clean%20logistics%20aesthetic%2C%20editorial%20photography&width=400&height=240&seq=guide-ware-v2&orientation=landscape',
    slug: '/article/sugargoo-warehouse-guide',
    internal: true,
  },
  {
    title: 'Sugargoo Coupon',
    subtitle: 'Latest discounts & deals',
    icon: 'ri-ticket-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20clean%20discount%20and%20coupons%20concept%20with%20stylish%20price%20tags%20on%20a%20minimal%20marble%20surface%2C%20warm%20peach%20and%20cream%20palette%2C%20soft%20natural%20lighting%2C%20modern%20editorial%20style&width=400&height=240&seq=guide-coupon-v2&orientation=landscape',
    slug: '/article/sugargoo-coupon-discount',
    internal: true,
  },
  {
    title: 'Is Sugargoo Legit?',
    subtitle: 'Trust & safety analysis',
    icon: 'ri-verified-badge-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20trust%20and%20security%20concept%20with%20a%20subtle%20shield%20motif%20on%20a%20clean%20glass%20surface%2C%20warm%20sand%20and%20soft%20cream%20palette%2C%20natural%20daylight%2C%20modern%20editorial%20photography%2C%20reassuring%20aesthetic&width=400&height=240&seq=guide-legit-v2&orientation=landscape',
    slug: '/article/is-sugargoo-legit-safe',
    internal: true,
  },
  {
    title: 'Shopping Guide 2026',
    subtitle: 'Complete beginner tutorial',
    icon: 'ri-guide-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20clean%20shopping%20guide%20concept%20with%20a%20modern%20tablet%20showing%20organized%20categories%2C%20surrounded%20by%20fashion%20items%20on%20a%20minimal%20desk%2C%20warm%20terracotta%20and%20cream%20palette%2C%20soft%20natural%20lighting&width=400&height=240&seq=guide-shop-v2&orientation=landscape',
    slug: '/article/best-sugargoo-spreadsheet-2026',
    internal: true,
  },
];

export const ratingCategories = [
  { category: 'Product Sourcing', rating: 'Excellent', score: 5 },
  { category: 'Warehouse Service', rating: 'Good', score: 4 },
  { category: 'Shipping Options', rating: 'Good', score: 4 },
  { category: 'Beginner Experience', rating: 'Excellent', score: 5 },
  { category: 'International Support', rating: 'Good', score: 4 },
];

export const shippingFactors = [
  { factor: 'Package Weight', impact: 'High', description: 'Heavier packages cost significantly more to ship internationally.' },
  { factor: 'Destination Country', impact: 'High', description: 'Shipping rates vary greatly depending on your delivery location.' },
  { factor: 'Shipping Line', impact: 'Medium', description: 'Different carriers offer varying speeds and price points.' },
  { factor: 'Package Dimensions', impact: 'Medium', description: 'Larger volumetric weight can increase your shipping cost.' },
];